import { rpc } from "#rpc";
import { createWishlist } from "@frend-digital/centra/client";

export const { WishlistProvider, useWishlist } = createWishlist({
	fetcher: rpc.products.byIds,
});
